import React, { useState, useEffect } from 'react';

import { routes as ROUTES } from 'constants/config';
import { getQueryParam } from 'utils/url';
import useFetch from 'components/shared/hooks/useFetch';
import { Popover } from 'ui';
import CertificationBadgeList from './CertificationBadgeList';
import CertificationConfettiPopover from './CertificationConfettiPopover';

const CertificationBadges = () => {
  const [showModal, setShowModal] = useState(false);
  const [certificateModalIdToShow, setCertificateModalIdToShow] =
    useState(null);
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);

  const { data = {} } = useFetch(ROUTES.LEARN_COMPLETED_CERTIFICATIONS({}));

  const {
    completed_count_since_last_view: completedCount,
    completed_certifications: certifications,
  } = data;

  const hasBadges = certifications && certifications.length > 0;

  useEffect(() => {
    if (completedCount) {
      setIsPopoverVisible(true);
    }
  }, [completedCount]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const toggleCertificateModal = id => {
    setCertificateModalIdToShow(id);
  };

  const closeCertificateModal = () => {
    setCertificateModalIdToShow(null);
  };

  const certificateId = getQueryParam(window.location.href, 'certificate_id');

  useEffect(() => {
    if (certificateId && data.completed_certifications) {
      const certificateIdInt = parseInt(certificateId, 10);
      if (
        data.completed_certifications
          .map(cert => cert.path.pathProgressId)
          .includes(certificateIdInt)
      ) {
        setCertificateModalIdToShow(certificateIdInt);
      }
    }
  }, [data, certificateId, setCertificateModalIdToShow]);

  return (
    <>
      {hasBadges && (
        <Popover
          align="middle"
          visible={isPopoverVisible}
          onClose={() => setIsPopoverVisible(false)}
          disableTabIndex
          activator={
            <CertificationBadgeList
              certifications={certifications}
              toggleCertificateModal={toggleCertificateModal}
              totalCertifications={data.total_certifications}
              toggleModal={toggleModal}
              showModal={showModal}
              certificateModalIdToShow={certificateModalIdToShow}
              closeCertificateModal={closeCertificateModal}
            />
          }
        >
          <CertificationConfettiPopover
            completedCount={completedCount}
            closePopover={() => setIsPopoverVisible(false)}
          />
        </Popover>
      )}
    </>
  );
};

CertificationBadges.propTypes = {};

export default CertificationBadges;
